import Swal from 'sweetalert2';

/**
 * Toast notification configuration
 */
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
});

/**
 * Show a success notification
 */
export const showSuccess = (title: string, text?: string, timer: number = 3000) => {
    return Toast.fire({
        icon: 'success',
        title,
        text,
        timer
    });
};

/**
 * Show an error notification
 */
export const showError = (title: string, text?: string) => {
    return Toast.fire({
        icon: 'error',
        title,
        text,
        timer: 5000
    });
};

/**
 * Show a warning notification
 */
export const showWarning = (title: string, text?: string) => {
    return Toast.fire({
        icon: 'warning',
        title,
        text,
        timer: 4000
    });
};

/**
 * Show an info notification
 */
export const showInfo = (title: string, text?: string) => {
    return Toast.fire({
        icon: 'info',
        title,
        text,
        timer: 3000
    });
};

/**
 * Show a confirmation dialog
 */
export const showConfirm = async (
    title: string,
    text?: string,
    confirmButtonText: string = 'Yes, delete it!',
    cancelButtonText: string = 'Cancel'
) => {
    const result = await Swal.fire({
        title,
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText,
        cancelButtonText
    });

    return result.isConfirmed;
};

/**
 * Show a loading notification
 */
export const showLoading = (title: string = 'Loading...', text?: string) => {
    Swal.fire({
        title,
        text,
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });
};

/**
 * Close any open notification
 */
export const closeNotification = () => {
    Swal.close();
};